import type { ImpersonationCandidateVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { ROLES } from "@user-management-context/shared/domain/types/enums/roles";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveImpersonationCandidates = createApiThunk<ImpersonationCandidateVM[], ROLES>(
  "users/retrieveImpersonationCandidates",
  async (role, { extra: { adminRepository } }) => {
    return adminRepository!.getImpersonationCandidates(role);
  },
);
